const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/forbidden.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { LOGIN_ROUTE, waitForAuth } from '@/shared/lib/authSession';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/forbidden')({
  beforeLoad: async () => {
    if (!(await waitForAuth())) {
      throw redirect({
        to: LOGIN_ROUTE,
        replace: true
      });
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});